import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { CardContent, Motion } from '@stepstone-genesis/components';
import { GradientBackground } from './GradientBackground.js';
import { ContentWrapper } from './ContentWrapper.js';
import { useAppSelector } from '../../../../redux/hooks.js';
import { activeViewSelector } from '../../../../redux/core/wrapperContext/wrapperContextSlice.js';
import { FadeTransition } from '../../../common/transitions/index.js';
import getLeftSideContent from './getLeftSideContent.js';
import { useMobile } from '../../../../helpers/hooks/index.js';
export const LeftSideContent = () => {
    const twoStepActiveState = useAppSelector(activeViewSelector);
    const isMobile = useMobile();
    const twoStepLoginState = twoStepActiveState === 'twoStepLogin';
    const twoStepRegistrationState = twoStepActiveState === 'twoStepRegistration';
    const hideLiftSideContent = (twoStepLoginState || twoStepRegistrationState) && isMobile;
    if (!twoStepActiveState) {
        return null;
    }
    return (_jsx(CardContent, { sx: {
            padding: 'spaceNone',
            width: ['100%', '48.5%'],
            position: 'relative',
            overflow: 'hidden',
            borderRadius: 'radiusL2',
            minHeight: ['auto', '93vh'],
            display: 'flex',
            justifyContent: ['left', 'center'],
        }, children: _jsxs(Motion, { layout: true, initial: false, animate: {
                height: hideLiftSideContent ? 0 : 'auto',
            }, transition: { duration: 0.4 }, sx: {
                overflow: 'hidden',
                pointerEvents: hideLiftSideContent ? 'none' : 'auto',
                willChange: 'height',
                width: '100%',
            }, children: [_jsx(GradientBackground, { isMobile: isMobile, variant: twoStepActiveState }), _jsx(ContentWrapper, { children: _jsx(FadeTransition, { transitionKey: twoStepActiveState, children: getLeftSideContent(twoStepActiveState) }) })] }, "left-side") }));
};
//# sourceMappingURL=LeftSideContent.js.map